import { cva, type VariantProps } from 'class-variance-authority'

export { default as Badge } from './Badge.vue'

export const badgeVariants = cva(
  'inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',

        // Availability Status Badge Variants
        'availability-status-full':
          'border-transparent bg-green-500 text-black hover:bg-green-500/80 dark:bg-green-400 dark:text-black dark:hover:bg-green-400/80',
        'availability-status-partial':
          'border-transparent bg-yellow-500 text-black hover:bg-yellow-500/80 dark:bg-yellow-400 dark:text-black dark:hover:bg-yellow-400/80',
        'availability-status-none':
          'border-transparent bg-red-500 text-black hover:bg-red-500/80 dark:bg-red-400 dark:text-black dark:hover:bg-red-400/80',
        'availability-status-disabled':
          'border-transparent bg-gray-500 text-black hover:bg-gray-500/80 dark:bg-gray-400 dark:text-black dark:hover:bg-gray-400/80',
      },
      size: {
        default: 'px-2.5 py-0.5 text-xs',
        sm: 'px-1.5 py-px text-2xs',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
